import { FC } from 'react';
import { TournamentStandingContainer } from './MasterTournament.style';

export const MasterTournamentTableLoader: FC = () => (
	<TournamentStandingContainer
		role="status"
		className="w-full animate-pulse  divide-y divide-gray-200 rounded-3xl  border border-gray-200 px-4 shadow dark:divide-gray-700 dark:border-gray-700"
	>
		<div className="home__headers">
			<div className="header__toggle__tab flex items-center justify-between">
				<div className="w-48  rounded-full bg-gray-300 dark:bg-gray-600">
					<div className="invisible">ay klam hena hidden</div>
				</div>
				<div className="flex flex-row gap-2">
					<div className="h-2.5 w-4 rounded-full bg-gray-300 dark:bg-gray-700"></div>
					<div className="h-2.5 w-4 rounded-full bg-gray-300 dark:bg-gray-700"></div>
				</div>
			</div>
			<div className="standing__table_container text__default">
				<div className="standing__table">
					{Array.from(new Array(10)).map((e, i) => {
						return (
							<div className="flex items-center justify-between py-2" key={i}>
								<div className="h-3 w-48 rounded-full bg-gray-300 dark:bg-gray-600"></div>
								<div className="h-2.5 w-6 rounded-full bg-gray-300 dark:bg-gray-700"></div>
								<div className="h-2.5 w-6 rounded-full bg-gray-300 dark:bg-gray-700"></div>
								<div className="h-2.5 w-6 rounded-full bg-gray-300 dark:bg-gray-700"></div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	</TournamentStandingContainer>
);
